import { PerspectiveCamera } from 'ohzi-core';
import { CameraManager } from 'ohzi-core';
import { Grid } from 'ohzi-core';
import { Debug } from 'ohzi-core';
import { SceneManager } from 'ohzi-core';
import { Screen } from 'ohzi-core';
import { Graphics } from 'ohzi-core';
import { ResourceContainer } from 'ohzi-core';
import { Input } from 'ohzi-core';
import { Time } from 'ohzi-core';

import { Color } from 'three';
import { AnimationMixer } from 'three';
import { Scene } from 'three';
import { AmbientLight } from 'three';
import { DirectionalLight } from 'three';
import { Raycaster } from 'three';
import { DoubleSide } from 'three';
import { sRGBEncoding } from 'three';
import { Vector2 } from 'three';
import { Vector3 } from 'three';
import { MeshBasicMaterial } from 'three';
import { RepeatWrapping } from 'three';
import { MeshPhongMaterial } from 'three';
import { CameraHelper } from 'three';
import { NearestFilter } from 'three';
import { LinearFilter } from 'three';

import CameraController from '../camera_controller/CameraController';
import SceneOptimizer from '../components/SceneOptimizer';
import GenericBuildingGroup from './Buildings/GenericBuildingGroup';

import StateHandler from '../states/StateHandler';
import Sky from './Sky';
import CloudsSystem from './CloudsSystem';

class SceneController
{
  init()
  {
    this.camera_controller = new CameraController();
  }

  start()
  {
    this.__init_camera();
    this.__init_camera_controller();

    this.add_lights();

    this.raycaster = new Raycaster();
    this.mouse = new Vector2();
    this.raycasteables = [];

    //Debug.draw_axis();
    //SceneManager.current.add(new Grid());
    // Here we add all objects into the scene
    Graphics.update();

    this.state_handler = new StateHandler(this.camera_controller);

    //return;
    let city_gltf = ResourceContainer.get_resource("city");
    let crowd = ResourceContainer.get_resource("crowd");
    let trees = ResourceContainer.get_resource("trees");

    city_gltf.scene.children[0].scale.set(1,1,1)
    city_gltf.scene.updateMatrixWorld(true )

    crowd.scene.children[0].scale.set(1,1,1)
    crowd.scene.updateMatrixWorld(true )

    trees.scene.children[0].scale.set(1,1,1)
    trees.scene.updateMatrixWorld(true )


    city_gltf.scene.traverse(((obj)=>{
      obj.castShadow = true;
      obj.receiveShadow = true;

      if (obj.material && obj.material.map) {
        //obj.material.map.encoding = sRGBEncoding;
        obj.material.transparent = false;
        obj.material = new MeshPhongMaterial({map : obj.material.map});
        obj.material.map.encoding = sRGBEncoding;

      }

      switch (obj.name) {
        case 'golf_place':
          this.golf = obj;
          break;

        case 'stadium_place':
          this.sport = obj;
          break;

        case 'factory_place':
          this.industrial = obj;
          break;

        case 'factory_default':
          this.factory = obj;
          break;

        case 'lollapalooza_place':
          this.venue = obj;
          break;

        case 'roads':
          this.roads = obj;
          break;

        case 'clouds':
          this.clouds = obj;
          break;

        case 'sea':
          this.sea = obj;
          break;

         case 'sea_waves':
          this.sea_waves = obj;
          break;

        case 'land2':
          this.land = obj;
          break;

        case 'convention_centre_place':
          this.convention_centre = obj;
          break;

        case 'ships_animated':
          this.ships_animated = obj;
          break;

        case 'instanced_lollapalooza_bars':
          this.lollapalooza_fence = obj;
          break;
        case 'instanced_bars_golf':
          this.golf_fence = obj;
          break;

        default:
      }
    }).bind(this));

    this.clouds = new CloudsSystem(this.clouds);

    this.lollapalooza_fence.traverse((obj)=>{
      if (obj.material) {
        obj.material.alphaTest = 0.5;
        obj.material.side = DoubleSide;
        obj.material.map.magFilter = NearestFilter
        obj.material.map.minFilter = NearestFilter
      }
    })
    this.golf_fence.traverse((obj)=>{
      if (obj.material) {
        obj.material.alphaTest = 0.5;
        obj.material.side = DoubleSide;
        obj.material.map.magFilter = NearestFilter
        obj.material.map.minFilter = NearestFilter
      }
    })
    //this.crowd.traverse((obj)=>{
    //  if (obj.material) {
    //    obj.material = new MeshBasicMaterial({map : obj.material.map});
    //    obj.material.map.magFilter = LinearFilter
    //    obj.material.map.minFilter = LinearFilter
    //  }
    //})
    new SceneOptimizer(city_gltf.scene);
    new SceneOptimizer(crowd.scene);
    new SceneOptimizer(trees.scene);
    this.scene = new GenericBuildingGroup(new Scene(), false);
    this.scene.position.set(-319.5, 0, -137)
    this.scene.rotation.x = Math.PI * 0.5;
    this.scene.rotation.z = - Math.PI * 0.5;
    this.scene.updateMatrixWorld(true );
    this.golf = new GenericBuildingGroup(this.golf, undefined, ResourceContainer.get_resource("camera_positions")["golf"]);
    this.sport = new GenericBuildingGroup(this.sport, undefined, ResourceContainer.get_resource("camera_positions")["sport"]);
    this.industrial = new GenericBuildingGroup(this.industrial, undefined, ResourceContainer.get_resource("camera_positions")["industrial"]);
    this.venue = new GenericBuildingGroup(this.venue, undefined, ResourceContainer.get_resource("camera_positions")["venue"]);
    this.convention_centre = new GenericBuildingGroup(this.convention_centre, undefined, ResourceContainer.get_resource("camera_positions")["convention_centre"]);

    this.scene.add_subscene(this.golf);
    this.scene.add_subscene(this.sport);
    this.scene.add_subscene(this.industrial);
    this.scene.add_subscene(this.venue);
    this.scene.add_subscene(this.convention_centre);

    this.golf.castShadow = true;
    this.sport.castShadow = true;
    this.industrial.castShadow = true;
    this.venue.castShadow = true;
    this.venue.receiveShadow = true;

    this.convention_centre.castShadow = true;
    this.convention_centre.receiveShadow = true;

    this.roads.position.z += 0.01;
    this.sea.position.z += 2;
    this.sea_waves.position.y += 1;
    this.golf.position.z += 0.01;

    city_gltf.scene.add(this.scene)
    SceneManager.current.add(city_gltf.scene)

    SceneManager.current.add(trees.scene)
    SceneManager.current.add(crowd.scene)

    this.scene.compute_bbox();
    this.scene.clear_raycasteable_mesh();
    
    this.scene.set_scene_camera_configuration(new Vector3( 1044, 332, -462), new Vector3( -197, 35, -126), 12.5, 105); 
    this.golf.set_scene_camera_configuration(new Vector3( -379, 46, 156), new Vector3( -332, 10, 226), 22, 214)

    this.sport.set_scene_camera_configuration(new Vector3( -313, 30, -298), new Vector3( -289, 8, -393), 12, 346)
    this.industrial.set_scene_camera_configuration(new Vector3(-246, 51, 113), new Vector3(-280, 10, 80), 33, 43)
    this.venue.set_scene_camera_configuration(new Vector3( 475, 59, -700), new Vector3( 358, 8, -589), 17, 133)
    this.convention_centre.set_scene_camera_configuration(new Vector3( 600, 22, -34), new Vector3( 560, 14, 26), 5, 146)



    this.sky = new Sky();
    this.sky.scale.setScalar( 5000 );
    SceneManager.current.add( this.sky );

    // Create an AnimationMixer, and get the list of AnimationClip instances
     this.mixer = new AnimationMixer( city_gltf.scene);
    //const clips = this.ships_animated.animations;

    // Play a specific animation
    let clips = [];
    const clip = city_gltf.animations[0];
    for (let i = 0 ; i < city_gltf.animations.length; i++) {
       const clip = city_gltf.animations[i];
       clips.push(clip)
    }

    // Play all animations
    clips.forEach( (( clip ) => {
      this.mixer.clipAction( clip ).play();
    }).bind(this) );

    this.state_handler.set_up(this.scene);
    setTimeout((()=>{
      this.state_handler.go_to_fly(this.scene);
    }).bind(this));

  }

  add_lights()
  {
    let light = new AmbientLight('#FFFFFF', 0.5);
    SceneManager.current.add(light);

    let directional_light = new DirectionalLight('#FFFFFF', 0.5);
    directional_light.position.set(0, 1000, 2000);
    SceneManager.current.add(directional_light);
    this.directional_light = directional_light;


    this.directional_light.castShadow = true; // default false

    //Set up shadow properties for the light
    this.directional_light.shadow.mapSize.width = 2048 * 2; // default
    this.directional_light.shadow.mapSize.height = 2048 * 2; // default
    this.directional_light.shadow.camera.near = 500; // default
    this.directional_light.shadow.camera.far = 3000; // default
    this.directional_light.shadow.camera.top = 5000; // default
    this.directional_light.shadow.camera.right = 5000; // default
    this.directional_light.shadow.camera.left = -5000; // default
    this.directional_light.shadow.camera.bottom = -5000; // default

    //const helper = new CameraHelper( this.directional_light.shadow.camera );
    //SceneManager.current.add( helper );
  }

  update()
  {
    this.clouds.update();

    this.mixer.update( Time.delta_time );

    this.camera_controller.update();

    this.state_handler.update();

    this.sky.update();

    this.directional_light.position.copy(this.sky.sun)
    this.directional_light.position.multiplyScalar(2000);
    this.scene.update_material();

    SceneManager.ui.children.forEach((obj) => {
      obj.update();
    })
  }

  __init_camera()
  {
    let camera = new PerspectiveCamera(45, Screen.aspect_ratio, 10, 10000);
    camera.updateProjectionMatrix();
    camera.position.z = 10;

    camera.clear_color.copy(new Color('#181818'));
    camera.clear_alpha = 1;
    CameraManager.current = camera;
  }

  __init_camera_controller()
  {
    this.camera_controller.set_camera(CameraManager.current);
    // this.camera_controller.set_idle();
    this.camera_controller.set_standard_mode();

    this.camera_controller.min_zoom = 0.1;
    this.camera_controller.max_zoom = 5000;
    this.camera_controller.reference_zoom = 1000;
    this.camera_controller.reference_position.set(0, 0, 0);
    this.camera_controller.set_rotation(50, -25);
  }
}

export default new SceneController();
